/**
    人员对话框(单选)
    visible 参数 bool (隐藏)
    title  参数 string （默认“人员(单选)”）
    data 参数 array （默认数据调用接口：entrust/getStaffAndOrganization-员工架构获取）
        例：[{key:'',title:'',children:[{key:'',title:'',...}]}]
    @confirmstaff function ([id],[title])
    @close function   (关闭)
 */
<template>
  <section v-if="visible" class="staff-section-box">
    <el-dialog :title="title || '人员(单选)'" :visible="visible" width="600px" @close="closeDialog">
      <div style="margin-bottom:20px;">
        <el-input placeholder="输入关键字进行过滤" v-model="filterText">
        </el-input>
      </div>
      <div class="user_dialog_role">
        <el-tree :data="data || getUserList" show-checkbox check-strictly node-key="key" ref="staff" :props="defaultProps" :default-checked-keys="[]" v-loading="loading" @check-change="handleClick" @node-click="nodeClick" :filter-node-method="filterNode">
        </el-tree>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="setUserData" :loading="dialogLoading">确 定</el-button>
      </div>
    </el-dialog>
  </section>
</template>
<script>
export default {
  data () {
    return {
      getUserList: [],
      checkedUser: [],
      dialogLoading: false,
      loading: false,
      defaultProps: {
        children: 'children',
        label: 'title',
        disabled: (data) => data.children
      },
      filterText: '',
    }
  },
  props: ['visible', 'title', 'data'],
  created () {
    // if(!this.data)  this.initData();
  },
  watch: {
    visible: function (v) {
      this.filterText = '';
      if (v) this.initData();
    },
    filterText (val) {
      this.$refs.staff.filter(val);
    }
  },
  methods: {
    initData () {
      if (!this.getUserList.length) {
        this.getUserList = [{}]
        this.loading = true;
        this.$http.get('entrust/getStaffAndOrganization').then((v) => {
          if (v.status === 200) {
            this.getUserList = v.data.data;
          }
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        })
      }

    },
    setUserData () {          //确认选择
      let permArr = [];
      let paramStr = [];
      this.$refs.staff.getCheckedNodes().forEach((v) => {
        if (!v.children) {
          permArr.push(v.key);
          paramStr.push(v.title)
        }
      })
      if (permArr.length > 0) {
        this.$emit('confirmstaff', permArr, paramStr)
      } else {
        this.$message({
          message: '数据为空，请选择！',
          type: 'warning'
        });
      }
    },
    closeDialog () {          //关闭
      this.$emit('close')
    },
    handleClick (data, checked, node) {
      if (checked == true && !data.children) {
        this.$refs.staff.setCheckedNodes([data]);
      }
    },
    nodeClick (data, checked, node) {
      this.$refs.staff.setCheckedNodes([data]);
    },
    filterNode (value, data) {           //用户搜索
      if (!value) return true;
      return data.title.toUpperCase().indexOf(value.toUpperCase()) !== -1;   //不区分大小写
      // return data.title.indexOf(value) !== -1;
    },
  }
}
</script>
<style scoped>
</style>